/**
 * Horizontal swipe on an element — touch AND mouse drag (pointer events), so it works on phones and when a desktop
 * browser is narrowed / in device mode. Vertical scrolling stays native (set `touch-action: pan-y` on the element).
 * Gestures starting on links/buttons are ignored (they keep working as taps/clicks).
 *
 * @param {HTMLElement} el
 * @param {(dir: 1|-1) => void} onSwipe  1 = next (swipe left), -1 = previous (swipe right)
 * @param {() => boolean} isEnabled      e.g. () => !_state.isDesktop
 */
const SWIPE_MIN = 40; // px

export const onSwipe = (el, onSwipe, isEnabled = () => true) => {
    if (!el) return;

    let start = null;
    let dragged = false;

    el.addEventListener('pointerdown', (e) => {
        if (!isEnabled() || e.button !== 0 || e.target.closest('a, button')) return;
        start = {x: e.clientX, y: e.clientY, id: e.pointerId};
        dragged = false;
    });

    el.addEventListener('pointermove', (e) => {
        if (!start || e.pointerId !== start.id) return;
        if (Math.abs(e.clientX - start.x) > 8) dragged = true;
    });

    const end = (e) => {
        if (!start || e.pointerId !== start.id) return;
        const dx = e.clientX - start.x;
        const dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
        onSwipe(dx < 0 ? 1 : -1);
    };

    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', () => {
        start = null;
    });

    // a mouse drag must not turn into a click on an image link / select text
    el.addEventListener('click', (e) => {
        if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
        }
    }, true);
    el.addEventListener('dragstart', (e) => {
        if (isEnabled()) e.preventDefault();
    });
};
